import React, { Fragment, useEffect } from 'react';
import { Breadcrumb, Typography, Divider, Input, Space, Button, Form, Row, Col } from 'antd';
import seekSolutionApi from "../../../utils/seekSolutionApi";
import { useNavigate, useParams } from "react-router-dom";

const { Title } = Typography;

const CreateSection = () => {
    const { courses_id } = useParams();
    const [form] = Form.useForm();
    const [loading, setLoading] = React.useState(false);
    const navigate =useNavigate()

    const handleSubmit = async (values: any) => {
        setLoading(true);
        console.log("values", values);

        try {
            if (!courses_id) {
                console.error("Course ID is undefined");
                return;
            }

            const body = {
                title: values.title
            }

            let apiRes = await seekSolutionApi.Sections.create(courses_id, body);
            navigate(`/lectures/${apiRes._id}/page/1`)

        } catch (error) {
            console.error("Error in handleSubmit", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Fragment>
            <Space direction="vertical" style={{ display: 'flex' }}>
                <Breadcrumb
                    items={[
                        { title: 'Management' },
                        { title: 'Courses' },
                        { title: courses_id },
                        { title: 'Section' },
                        { title: 'Create' },
                    ]}
                />
                <Title level={2}>Create Section</Title>
                <Divider />
                <Form
                    onFinish={handleSubmit}
                    form={form}
                    initialValues={{ ...JSON.parse(localStorage.getItem("section_draft") as string) }}
                    layout="vertical"
                >
                    <Row gutter={[12, 8]} justify={'space-between'}>
                        <Col span={16}>
                            <Form.Item name="title" label="Title" required tooltip="This is a required field">
                                <Input type="text" placeholder='Write your title' />
                            </Form.Item>
                            <Button type="primary" htmlType="submit" loading={loading}>Create</Button>
                        </Col>
                        <Col span={8}></Col>
                    </Row>
                </Form>
            </Space>
        </Fragment>
    );
}

export default CreateSection;
